import React from 'react';
import BaseSelectField from '../BaseSelectField';
import {
  lifeCycleEntitiesMap,
  selectFieldNames,
} from '../../constants/lifeCycle';
import { useRoomStages } from '../../../../../queries/useRoomStages';

const settings = {
  name: selectFieldNames[lifeCycleEntitiesMap.stage],
  label: 'Стадия',
};

const SelectStage = ({ roomId, control, initialValue, setIsFetchError }) => {
  const { data, isFetching, refetch } = useRoomStages({ addressId: roomId });

  return (
    <BaseSelectField
      data={data}
      isFetching={isFetching}
      refetch={refetch}
      fetchErrMsg="Не удалось загрузить список доступных стадий"
      control={control}
      fieldSettings={settings}
      initialValue={initialValue}
      setIsFetchError={setIsFetchError}
    />
  );
};

export default SelectStage;
